import { useState } from 'react';
import { useCreateOwnerContractContext, useUserLanguage } from '@/customHooks';
import textsData from '@/textData/CreateContractsTexts.json';

export const SelectOwnerContractAmountMenu = () => {
  const { state, setContractAmount } = useCreateOwnerContractContext();
  const userLanguage = useUserLanguage();

  const [amountInput, setAmountInput] = useState<string>(state.contractAmount ?? '');

  const rootTexts = userLanguage === 'es' ? textsData.es : textsData.en;
  const texts = rootTexts.ownerContract.contractAmount;

  const handleAmountBlur = () => {
    const normalized = amountInput.trim();
    if (!normalized) {
      setContractAmount(null);
      return;
    }
    setContractAmount(normalized);
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-2xl">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col gap-6">
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-2">{texts.title}</h2>
            <p className="text-sm text-gray-500">{texts.helper}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
            <div className="flex flex-col gap-2">
              <label className="text-sm font-semibold text-gray-700" htmlFor="contractAmount">
                {texts.fields.amountLabel}
              </label>
              <div className="relative">
                <input
                    id="contractAmount"
                    type="number"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-100 rounded-xl focus:ring-2 focus:ring-(--color-primary-200) focus:border-(--color-primary) outline-hidden transition-all duration-200 text-sm"
                    value={amountInput}
                    placeholder="0.00"
                    onChange={(event) => setAmountInput(event.target.value)}
                    onBlur={handleAmountBlur}
                    min={0}
                />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="text-sm font-semibold text-gray-700">
                {texts.fields.currencyLabel}
              </div>
              <div className="w-full px-4 py-3 bg-gray-50 border border-gray-100 rounded-xl focus:ring-2 focus:ring-(--color-primary-200) focus:border-(--color-primary) outline-hidden transition-all duration-200 text-sm">
                EUR
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
